var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import _ from 'lodash';
import './EditLocation.scss';

var EditLocationCtrl = function () {
    function EditLocationCtrl($scope, $state, $q, StateUtils, ViewModelService, ModalService, CPCoverablesService, LocaleService, $filter, originState) {
        _classCallCheck(this, EditLocationCtrl);

        var LocationDTOName = 'edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.LocationDTO';
        this.$state = $state;
        this.ModalService = ModalService;
        this.model = StateUtils.activeDataForState(true).model;
        this.jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;
        this.sessionId = SessionUtil.getSessionUUID(this.model);
        this.CPCoverablesService = CPCoverablesService;
        this.$filter = $filter;
        this.originState = originState;
        this.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');

        this.location = _.find(this.model.lobData.commercialProperty.coverables.locations.value, function (location) {
            return location.publicID === $state.params.publicID;
        });
        this.locationView = ViewModelService.create(_.cloneDeep(this.location), 'pc', LocationDTOName);
    }

    _createClass(EditLocationCtrl, [{
        key: 'save',
        value: function save(locationForm) {
            locationForm.submitted = true;
            if (locationForm.invalid) {
                return;
            }
            this._updateLocation(this.locationView.value);
        }
    }, {
        key: 'cancel',
        value: function cancel(locationForm) {
            var _this = this;

            var isLocationUpdated = false;
            if (locationForm.$pristine) {
                this._backToOrigin(isLocationUpdated);
            } else {
                this._showCancelModal().then(function () {
                    return _this._backToOrigin(isLocationUpdated);
                });
            }
        }
    }, {
        key: 'navigateToLocationView',
        value: function navigateToLocationView(locationForm) {
            var _this2 = this;

            var navigate = function navigate() {
                return _this2.$state.go('cpBuildingWizardViewLocation', { publicID: _this2.location.publicID });
            };
            if (locationForm.$pristine) {
                navigate();
            } else {
                this._showCancelModal().then(function () {
                    return navigate();
                });
            }
        }
    }, {
        key: '_showCancelModal',
        value: function _showCancelModal() {
            var modalTitle = 'quoteandbind.cp.buildingsWizard.EditLocation.Cancel Changes?';
            var modalMessage = 'quoteandbind.cp.buildingsWizard.EditLocation.You will lose all the change youve made. Are you sure you want to cancel?';
            var modalConfirm = this.$filter('translate')('quoteandbind.cp.buildingsWizard.EditLocation.Yes');
            var modalCancel = this.$filter('translate')('quoteandbind.cp.buildingsWizard.EditLocation.No');
            return this.ModalService.showWarning(modalTitle, modalMessage, undefined, modalConfirm, undefined, modalCancel).result;
        }
    }, {
        key: '_backToOrigin',
        value: function _backToOrigin(isLocationUpdated) {
            if (this.$state.params.buildingPublicID) {
                var params = {
                    publicID: this.$state.params.buildingPublicID,
                    isLocationUpdated: isLocationUpdated,
                    isCoverageOpen: false
                };

                this.$state.go('cpBuildingWizardViewBuilding', params);
            } else {
                this.$state.go(this.originState.state, this.originState.params);
            }
        }
    }, {
        key: '_updateLocation',
        value: function _updateLocation(location) {
            var _this3 = this;

            var isLocationUpdated = true;
            this.updateLocationPromise = this.CPCoverablesService.updateCPLocation(this.jobID, location, SessionUtil.getSessionUUID(this.model));
            this.updateLocationPromise.then(function (updatedLocation) {
                var locations = _this3.model.lobData.commercialProperty.coverables.locations.value;
                var locIndex = _.findIndex(locations, function (aLocation) {
                    return aLocation.publicID === _this3.$state.params.publicID;
                });
                locations.splice(locIndex, 1, updatedLocation);
                _this3._backToOrigin(isLocationUpdated);
            }).catch(function () {
                var modalTitle = 'quoteandbind.cp.buildingsWizard.EditLocation.Error updating location';
                var modalMessage = 'quoteandbind.cp.buildingsWizard.EditLocation.Please check for errors and try again';
                _this3.ModalService.showWarning(modalTitle, modalMessage);
            });
        }
    }]);

    return EditLocationCtrl;
}();

EditLocationCtrl.$inject = ['$scope', '$state', '$q', 'StateUtils', 'ViewModelService', 'ModalService', 'qnb.cpCoverablesService', 'LocaleService', '$filter', 'originState'];

export default EditLocationCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/EditLocation/EditLocationCtrl.js
// module id = 1824
// module chunks = 0